<template>
    <a href="#" class="button"
    v-if="button"
    :class="getClass"
    :ref_testcafe="testcafeRef"
    v-on:click.prevent="handleError">
        {{getFullError | parseTicketError(true)}}
    </a> <!-- TODO DOMAGOJ accept/confirmation button -->
  </template>

<script>
export default {
    name: 'SingleBetslipErrorButton',
    props:
    [
        'button',
        'error',
        'buttonType',
    ],
    data()
    {
        return {
            timerTimeout: null,
            timer: null,
        };
    },
    created()
    {
        if (this.button.hasTimer)
        {
            this.timer = parseInt(this.error.autohide / 1000, 10);
            this.changeTimer();
        }
    },
    beforeDestroy()
    {
        clearTimeout(this.timerTimeout);
        this.timerTimeout = null;
    },
    methods:
    {
        handleError()
        {
            if (this.error.id === 'session_not_valid')
            {
                window.emit('betslipError', {
                    error: true,
                    code: 'session_not_valid',
                });
            }
            if (this.error.id === 'error: network error')
            {
                window.emit('networkError', {
                    error: true,
                    code: 'network_error',
                });
            }
            if (this.error.id === 'token_not_found_or_has_expired')
            {
                window.emit('betslipError', {
                    error: true,
                    code: 'token_not_found_or_has_expired',
                });
            }
            if (this.error.id === 'request_timed_out')
            {
                window.emit('networkError', {
                    error: true,
                    code: 'request_timed_out',
                });
            }
            if (this.error.id === 'request_server_internal_error')
            {
                window.emit('networkError', {
                    error: true,
                    code: 'request_server_internal_error',
                });
            }
            if (this.error.id === 'axios_network_error')
            {
                window.emit('networkError', {
                    error: true,
                    code: 'axios_network_error',
                });
            }
            this.button.callback();
        },
        changeTimer()
        {
            clearTimeout(this.timerTimeout);

            this.timerTimeout = setTimeout(() =>
            {
                const timer = parseInt(
                    ((this.error.timestampCreate + this.error.autohide)
                    - new Date().getTime()) / 1000,
                    10,
                ) + 1;

                if (timer >= 0)
                {
                    this.timer = timer;
                    this.changeTimer();
                }
                else
                {
                    this.timer = 0;
                }
            }, 1000);
        },
    },
    computed:
    {
        getFullError()
        {
            return {
                text: this.errorText,
                params: {
                    ...this.errorParams,
                    timer: this.timer,
                },
            };
        },
        testcafeRef()
        {
            if (this.buttonType === 'accept')
            {
                return 'warningButtonAccept';
            }

            return 'warningButtonReject';
        },
        getClass()
        {
            if (this.buttonType === 'accept')
            {
                return 'button-blue-accept';
            }

            return 'button-cancel';
        },
        errorParams()
        {
            let paramsOut = {};

            if (this.button.text)
            {
                if (this.button.params)
                {
                    paramsOut = {
                        ...this.button.params,
                    };
                }
                else if (this.button.text.params)
                {
                    if (this.button.text.params)
                    {
                        paramsOut = {
                            ...this.button.text.params,
                        };
                    }
                }

                return paramsOut;
            }

            return this.button.text;
        },
        errorText()
        {
            if (this.button.text.text)
            {
                return this.button.text.text;
            }

            return this.button.text;
        },
    },
};
</script>
